// extracted by mini-css-extract-plugin
export default {"productDescription":"Y_-z","featuredDescription":"Z_-z","description":"__-z","more":"aaa-z","descriptionSku":"baa-z"};